import {Button, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Add01Icon} from "@hugeicons/core-free-icons";

export const CampaignsHeader = ({onCreate}) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h5" fontWeight={600}>Campaigns</Typography>
      <Button
        variant="primary" color="info" size="small"
        sx={{borderRadius: 2, boxShadow: 0}}
        startIcon={<HugeiconsIcon icon={Add01Icon} size={18}/>}
        onClick={onCreate}
      >
        Create campaign
      </Button>
    </Stack>
  )
}
